export default __webpack_public_path__ + "static/media/document-upload-header.b84defa7.svg";